import React from 'react';
import { useState } from 'react';
import { Box, TextField, Stack, Button } from '@mui/material';

const Layer = ({ layer, onAltChange, onClick, onDragStart, onDragEnter }) => {

    const [editableContent, setEditableContent] = useState(layer.alt);
    const [isEdited, setIsEdited] = useState(false);
    const [editOptions, setEditOptions] = useState(false);

    const handleTextFieldChange = (event) => {
        setEditableContent(event.target.value);
        setIsEdited(true);
    };

    const handleRelabel = async () => {
        onAltChange(layer.id, editableContent);
        setIsEdited(false);
    };

    const handleAltChange = (event) => {
        onAltChange(layer.id, event.target.value);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid lightgray',
                padding: '5px',
                borderRadius: '4px',
                backgroundColor: 'white',
                minHeight: '48px',
                width: '100%',
                marginBottom: '1em',
            }}
            draggable
            onDragStart={onDragStart}
            onDragEnter={onDragEnter}
        >
            <img src={"https://www.svgrepo.com/show/459043/drag-handle.svg"}
                style={{ width: '16px', top: '0', position: 'relative', transform: "translateY(-20px )" }}>
            </img>
            <Box sx={{ width: '48px', height: '48px', overflow: 'hidden' }}>
                <img
                    src={layer.src}
                    id={`preview-${layer.id}`}
                    alt={layer.alt}
                    style={{
                        width: '100%',
                        height: 'auto',
                        cursor: 'pointer',
                        backgroundColor: '#eee',
                        border: '1px solid lightgray',
                        marginRight: '10px',
                    }}

                    onClick={onClick}
                />
            </Box>

            <TextField
                fullWidth
                value={layer.alt}
                onChange={handleAltChange}
                variant="outlined"
                size="small"
                placeholder="Layer"
                sx={{ height: '48px', marginLeft: '10px' }}
                onDragStart={(e) => e.stopPropagation()}
                onDragEnter={(e) => e.stopPropagation()}
            />

            <Stack direction="row">

                {editOptions && (
                    <div>
                        <Stack direction="row">
                            <TextField
                                sx={{ backgroundColor: "white", border: "none", width: "100%" }}

                                onChange={handleTextFieldChange}
                            />
                            {isEdited && (
                                <Button variant="contained" color="secondary" onClick={handleRelabel} >
                                    RELABEL
                                </Button>
                            )}
                        </Stack>
                    </div>
                )}
            </Stack>
        </Box>
    );
};

export default Layer;
